// src/App.js
import React, { useMemo, useState, useCallback, useEffect} from 'react';
import './App.css';
import MaintenancePage from './components/MaintenancePage';
import axios from 'axios';

export default function App(){
  const [openIds, setOpenIds] = useState(() => new Set()); // секції за замовчуванням згорнуті

  // ====== Maintenance (1 в 1 логіка як у твоєму старому App) ======
  const isMaintenanceMode = false;
  const [isIpAllowed, setIsIpAllowed] = useState(false);

  useEffect(() => {
    const checkIpRoute = async () => {
      try {
        const response = await axios.get('/api/ip/check-ip');
        if (response.data && response.data.allowed === true) setIsIpAllowed(true);
        else setIsIpAllowed(false);
      } catch (error) {
        console.error('Error checking IP on server:', error);
        setIsIpAllowed(false);
      }
    };

    checkIpRoute();
  }, []);

  const isMaintenanceActive = isMaintenanceMode && !isIpAllowed;

  // ====== Контакти ======
  const tgUrl = 'https://t.me/qpcoreadmin';
  const waUrl = 'https://wa.me/+48784196320';

  // Обкладинка
  const coverUrl = '/gallery/1.jpeg';

  // ====== Lightbox (фото на весь екран) ======
  const [lightboxSrc, setLightboxSrc] = useState('');
  const [lightboxAlt, setLightboxAlt] = useState('');
  const [lbOpen, setLbOpen] = useState(false);

  const closeLb = useCallback(() => {
    setLbOpen(false);
    setTimeout(() => {
      setLightboxSrc('');
      setLightboxAlt('');
    }, 220);
  }, []);

  useEffect(() => {
    if (!lbOpen) return;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') closeLb();
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [lbOpen, closeLb]);

  useEffect(() => {
    // блок скролу під лайтбокс
    if (!lbOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [lbOpen]);

  const openLb = useCallback((src, alt='') => {
    setLightboxSrc(src);
    setLightboxAlt(alt);
    setLbOpen(true);
  }, []);

  // ====== ТРЕКІНГ / SEND EVENT ======
  const sendEvent = useCallback(async (eventName) => {
    const payload = JSON.stringify({ eventName });

    try{
      if (navigator.sendBeacon){
        const blob = new Blob([payload], { type: 'application/json' });
        navigator.sendBeacon('/api/track-event', blob);
        return;
      }
    }catch{}

    try{
      await fetch('/api/track-event', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true,
      });
    }catch{}
  }, []);

  const fire = useCallback(async (name) => {
    try { await sendEvent(name); } catch {}
  }, [sendEvent]);

  const onTelegramClick = () => fire('Telegram Tunnel');
  const onWhatsAppClick = () => fire('WhatsApp Tunnel');

  // ====== АКОРДЕОНИ ======
  const toggle = (id) => {
    setOpenIds(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  // ====== ГАЛЕРЕЯ (public/gallery/1.jpg...) ======
  const photoGallery = useMemo(() => ([
    { id:'p1', src:'/gallery/1.jpeg', alt:'Brand photo 1' },
    { id:'p2', src:'/gallery/2.jpeg', alt:'Brand photo 2' },
    { id:'p3', src:'/gallery/3.jpeg', alt:'Brand photo 3' },
    { id:'p4', src:'/gallery/4.jpeg', alt:'Brand photo 4' },
    { id:'p5', src:'/gallery/5.jpeg', alt:'Brand photo 5' },
    { id:'p6', src:'/gallery/6.jpg', alt:'Brand photo 6' },
    { id:'p7', src:'/gallery/7.jpeg', alt:'Brand photo 7' },
    { id:'p8', src:'/gallery/8.jpeg', alt:'Brand photo 8' },
  ]), []);

  // ====== ВІДЕО РОБОТИ (public/brand-videos/*.mov) ======
  const brandVideos = useMemo(() => ([
    { id: 'v1', src: '/brand-videos/1.mp4', title: 'Brand video 1' },
    { id: 'v2', src: '/brand-videos/2.mp4', title: 'Brand video 2' },
    { id: 'v3', src: '/brand-videos/3.mp4', title: 'Brand video 3' },
    { id: 'v4', src: '/brand-videos/4.mp4', title: 'Brand video 4' },
    { id: 'v5', src: '/brand-videos/5.mp4', title: 'Brand video 5' },
    { id: 'v6', src: '/brand-videos/6.mp4', title: 'Brand video 6' },
    { id: 'v7', src: '/brand-videos/7.mp4', title: 'Brand video 7' },
    { id: 'v8', src: '/brand-videos/8.mp4', title: 'Brand video 8' },
    { id: 'v9', src: '/brand-videos/9.mp4', title: 'Brand video 9' },
    { id: 'v10', src: '/brand-videos/10.mp4', title: 'Brand video 10' },
  ]), []);

  // ====== ВІДЕО КЛІПИ (2 шт + твої лінки) ======
  const clips = useMemo(() => ([
    {
      id: 'clip1',
      name: 'Твій зайчик пише - 200 разів за хвилину (Official Video)',
      youtube: 'https://youtu.be/cnnoJLUkpmk?si=mop2zKXndSEIIskn',
      text: [
        'Відео кліп з моєю участю.',
      ],
    },
    {
      id: 'clip2',
      name: 'Dlvflex - Flexi (Official Music Video)',
      youtube: 'https://youtu.be/Nl748hOesOk?si=_kSqKUNASkfrrZ_S',
      text: [
        'Відео кліп з моєю участю.',
      ],
    },
  ]), []);

  const sections = useMemo(() => ([
    {
      id: 'gallery',
      title: 'Галерея',
      meta: 'Фото роботи для брендів • портфоліо',
      body: (
        <div className="grid">
          {photoGallery.map((ph) => (
            <button
              key={ph.id}
              type="button"
              className="mediaCard mediaCardBtn"
              onClick={() => openLb(ph.src, ph.alt)}
              aria-label={`Відкрити фото: ${ph.alt}`}
            >
              <div className="mediaFrame mediaFrame916" aria-label={ph.alt}>
                <img
                  className="mediaImg"
                  src={ph.src}
                  alt={ph.alt}
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                    const phEl = e.currentTarget.parentElement?.querySelector('.mediaPlaceholder');
                    if (phEl) phEl.style.display = 'grid';
                  }}
                />
                <div className="mediaPlaceholder" style={{ display: 'none' }}>
                  <div className="placeholderText">Немає зображення</div>
                </div>

                <div className="tapHint" aria-hidden="true">Натисни • fullscreen</div>
              </div>
            </button>
          ))}
        </div>
      ),
    },
    {
      id: 'video-works',
      title: 'Відео роботи',
      meta: 'Відео для брендів • UGC / reels / промо',
      body: (
        <div className="grid">
          {brandVideos.map((v) => (
            <div key={v.id} className="mediaCard">
              <div className="mediaFrame mediaFrame916 mediaFrameVideo" aria-label={v.title}>
                <video
                  className="mediaVideo"
                  src={v.src}
                  controls
                  playsInline
                  preload="metadata"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                    const phEl = e.currentTarget.parentElement?.querySelector('.mediaPlaceholder');
                    if (phEl) phEl.style.display = 'grid';
                  }}
                />
                <div className="mediaPlaceholder" style={{ display: 'none' }}>
                  <div className="placeholderText">Немає відео</div>
                </div>
              </div>

              <div className="mediaCaption">{v.title}</div>
            </div>
          ))}
        </div>
      ),
    },
    {
      id: 'video-clips',
      title: 'Відео кліпи',
      meta: 'YouTube • кліпи / роботи',
      body: (
        <div className="clipsList">
          {clips.map((c) => {
            const ytId = getYoutubeId(c.youtube);

            return (
              <div key={c.id} className="clipCard">
                <div className="clipTitleRow">
                  <div className="clipName">{c.name}</div>
                  <div className="clipBadge">YouTube</div>
                </div>

                <div className="clipInner">
                  <div className="videoFrame">
                    <iframe
                      className="iframe"
                      src={`https://www.youtube-nocookie.com/embed/${ytId}`}
                      title={`${c.name} video`}
                      loading="lazy"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    />
                  </div>

                  <div className="clipText">
                    {c.text.map((p, idx) => <p key={idx}>{p}</p>)}

                    <a className="youtubeLink" href={c.youtube} target="_blank" rel="noreferrer">
                      Відкрити на YouTube
                      <span className="linkArrow" aria-hidden="true">↗</span>
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ),
    },
  ]), [photoGallery, brandVideos, clips, openLb]);

  if (isMaintenanceActive) return <MaintenancePage />;

  return (
    <div className="page">
      <header className="hero">
        <div className="coverCol">
          <div className="coverFrame" aria-label="Обкладинка emochickx">
            <img
              className="coverImg"
              src={coverUrl}
              alt="emochickx cover"
              loading="eager"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
                const ph = e.currentTarget.parentElement?.querySelector('.coverPlaceholder');
                if (ph) ph.style.display = 'grid';
              }}
            />
            <div className="coverPlaceholder" style={{ display: 'none' }}>
              <div className="placeholderText">Немає зображення</div>
            </div>

            <div className="coverGlow" aria-hidden="true" />
            <div className="coverScrim" aria-hidden="true" />
          </div>

          <div className="miniBadges">
            <span className="badge">Зріст: 160 см</span>
            <span className="badgeStrong">Параметри: 84-60-86 см</span>
            <span className="badge">Стопа: 24 см</span>
          </div>
        </div>

        <div className="infoCol">
          <h1 className="title">emochickx</h1>

          <p className="subtitle">
            Портфоліо контент-кріейтора для брендів, бізнесів, блогерів і артистів.
          </p>

          <div className="textBlock">
            <p>
              Фото, UGC та відео, які виглядають актуально, неформально й впевнено. 
	      Підбираю референси, світло, ритм і подачу під задачу бренду.
            </p>
            <p>
              Можлива співпраця у форматі контент-пакетів або окремих зйомок. 
	      Без зайвих форм — напишіть у меседжер і домовимося про деталі.
            </p>
          </div>

          <div className="ctaCard" id="collab">
            <div className="ctaTitle">Співпраця</div>
            <div className="ctaText">
              Зв’яжіться у зручному месенджері та опишіть задачу. Я відповім із варіантом реалізації та умовами співпраці.
            </div>

            <div className="ctaButtons">
              <a
                className="btn btnPrimary"
                href={tgUrl}
                target="_blank"
                rel="noreferrer"
                onClick={onTelegramClick}
              >
                <IconTelegram className="btnIcon" />
                <span className="btnLabel">Telegram</span>
              </a>

              <a
                className="btn btnGhost"
                href={waUrl}
                target="_blank"
                rel="noreferrer"
                onClick={onWhatsAppClick}
              >
                <IconWhatsApp className="btnIcon" />
                <span className="btnLabel">WhatsApp</span>
              </a>
            </div>
          </div>
        </div>
      </header>

      <main className="main" id="portfolio">
        <div className="sectionHead">
          <h2 className="sectionTitle">Портфоліо</h2>
          <div className="sectionHint">Секції згорнуті — відкривай по черзі.</div>
        </div>

        <div className="list">
          {sections.map((s) => {
            const isOpen = openIds.has(s.id);

            return (
              <section key={s.id} className="card">
                <button
                  type="button"
                  className="cardHeader"
                  onClick={() => toggle(s.id)}
                  aria-expanded={isOpen ? 'true' : 'false'}
                >
                  <div className="cardHeaderLeft">
                    <div className="cardTitleRow">
                      <div className="cardTitle">{s.title}</div>
                      <div className="cardBadge">{s.meta}</div>
                    </div>
                    <div className="cardMeta">Натисни, щоб розгорнути</div>
                  </div>

                  <span className={`pmWrap ${isOpen ? 'pmOpen' : ''}`} aria-hidden="true">
                    <span className="pm" />
                  </span>
                </button>

                <div className={`cardBody ${isOpen ? 'cardBodyOpen' : ''}`}>
                  <div className="cardInner">
                    {s.body}
                  </div>
                </div>
              </section>
            );
          })}
        </div>

        <footer className="footerCta">
          <div className="ctaTitle">Обговоримо деталі?</div>
          <div className="ctaText">
            Напиши в Telegram або WhatsApp — швидко узгодимо формат: фото / UGC / reels / промо.
          </div>

          <div className="ctaButtons">
            <a
              className="btn btnPrimary"
              href={tgUrl}
              target="_blank"
              rel="noreferrer"
              onClick={onTelegramClick}
            >
              <IconTelegram className="btnIcon" />
              <span className="btnLabel">Telegram</span>
            </a>

            <a
              className="btn btnGhost"
              href={waUrl}
              target="_blank"
              rel="noreferrer"
              onClick={onWhatsAppClick}
            >
              <IconWhatsApp className="btnIcon" />
              <span className="btnLabel">WhatsApp</span>
            </a>
          </div>
        </footer>
      </main>

      {/* LIGHTBOX */}
      <div
        className={`lb ${lbOpen ? 'lbOpen' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label="Перегляд фото"
        onMouseDown={(e) => {
          if (e.target === e.currentTarget) closeLb();
        }}
        onTouchStart={(e) => {
          if (e.target === e.currentTarget) closeLb();
        }}
      >
     
      <div className="lbInner">
	  <div className="lbFrame">
	    <button type="button" className="lbClose" onClick={closeLb} aria-label="Закрити">
	  <svg className="lbCloseIcon" viewBox="0 0 24 24" aria-hidden="true">
	    <path d="M6.2 6.2 17.8 17.8M17.8 6.2 6.2 17.8" />
	  </svg>
	</button>

	    {lightboxSrc ? (
	      <img
		className="lbImg"
		src={lightboxSrc}
		alt={lightboxAlt || 'Photo'}
		draggable="false"
	      />
	    ) : null}
	  </div>
	</div>

      </div>
    </div>
  );
}

function getYoutubeId(url){
  try{
    const u = new URL(url);
    if (u.hostname.includes('youtu.be')) return u.pathname.replace('/', '');
    if (u.searchParams.get('v')) return u.searchParams.get('v');
    const parts = u.pathname.split('/').filter(Boolean);
    const idx = parts.indexOf('embed');
    if (idx >= 0 && parts[idx + 1]) return parts[idx + 1];
  }catch(e){}
  const m = String(url).match(/(?:youtu\.be\/|v=|\/embed\/)([A-Za-z0-9_-]{6,})/);
  return m?.[1] || '';
}

/* SVG icons */
function IconTelegram({ className = '' }){
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M9.2 14.6 8.9 19c.5 0 .7-.2 1-.5l2.4-2.3 5 3.7c.9.5 1.6.2 1.8-.8l3.3-15.5c.3-1.2-.5-1.7-1.4-1.3L2.3 10.2c-1.1.4-1.1 1.1-.2 1.4l4.6 1.4L17.8 6c.5-.3 1-.1.6.2L9.2 14.6Z"/>
    </svg>
  );
}

function IconWhatsApp({ className = '' }){
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 2a9.7 9.7 0 0 0-8.4 14.6L2.6 22l5.6-1.5A9.7 9.7 0 1 0 12 2Zm0 17.7c-1.5 0-3-.4-4.3-1.2l-.3-.2-3.3.9.9-3.2-.2-.3A7.7 7.7 0 1 1 12 19.7Z"/>
      <path d="M16.6 13.7c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.2l-.8 1c-.2.3-.4.3-.7.1-1.7-.8-2.8-2.1-3.2-2.8-.1-.3 0-.5.1-.6l.6-.7c.2-.2.2-.4.3-.6 0-.2 0-.4-.1-.6l-.9-2.1c-.2-.5-.5-.4-.7-.4h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.2-1.2 2.9 0 1.7 1.2 3.4 1.4 3.6.2.2 2.4 3.6 5.8 5 .8.3 1.5.5 2 .6.8.3 1.6.2 2.2.1.7-.1 1.7-.7 1.9-1.4.2-.7.2-1.3.1-1.4 0-.1-.2-.2-.5-.3Z"/>
    </svg>
  );
}
